import { login, syncAssignedOrders } from '../services/api';
import { renderLayout } from '../components/layout';
import { syncClientOptions } from '../services/sync';
import { showLoadingOverlay, updateLoadingMessage, hideLoadingOverlay } from '../components/loading-overlay';

export function initLogin() {
  const content = `
    <h3 class="ac mtlogin">Login</h3>
    <div id="error-message" class="warning-text ac"></div>
    <form id="login-form" class="entity-form">
      <input type="text" id="username" placeholder="Username" class="text-input">
      <input type="password" id="password" placeholder="Password" class="text-input" >
      <button type="submit">Login</button>
    </form>
  `;
  renderLayout(content);

  document.getElementById('login-form')!.addEventListener('submit', async (e) => {
    e.preventDefault();
    
    // Get form elements
    const form = document.getElementById('login-form') as HTMLFormElement;
    const username = (document.getElementById('username') as HTMLInputElement).value;
    const password = (document.getElementById('password') as HTMLInputElement).value;

    const errorMessageEle = (document.getElementById('error-message') as HTMLInputElement);
    if(username.trim() === '' || password.trim() === '') {
      errorMessageEle.innerText = 'Please enter both username and password.';
      return;
    }
    else {
      errorMessageEle.innerText = '';
    }

    //const submitButton = form.querySelector('button[type="submit"]') as HTMLButtonElement;
    
    // Disable form to prevent spam
    const inputs = form.querySelectorAll('input, button');
    inputs.forEach(input => (input as HTMLInputElement | HTMLButtonElement).disabled = true);
    
    // Show loading overlay
    showLoadingOverlay('Logging in...');
    
    try {
      var result = await login(username, password);
      if(result !== null) {
        updateLoadingMessage('Loading interface...');
        await syncAssignedOrders();
        await syncClientOptions(); 
      }
      window.location.href = '/dashboard';
    } catch (error) {
      // Hide loading overlay and re-enable form on error
      hideLoadingOverlay();
      inputs.forEach(input => (input as HTMLInputElement | HTMLButtonElement).disabled = false);
      errorMessageEle.innerText =  'An error occurred during login. Please try again.'; //(error as Error).message ||
    }
  });
}
